import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Resources Nav Filled Icon
 *
 * @file ResourcesNavFilled.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const ResourcesNavFilled = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#94E7EA" />
    <path
      d="M28.5909 27H11.4091V13.5C11.4091 13.2239 11.6329 13
    11.9091 13H15.5858C15.851 13 16.1054 13.1054 16.2929 13.2929L18
    15H28.5909V27ZM28.4 13.25H19.1L17.593 11.6354C17.2148 11.2301
    16.6853 11 16.1309 11L11.6 11C10.4345 11 9.5 12.0013 9.5 13.25V26.75C9.5
    27.9926 10.4402 29 11.6 29H28.4C29.5598 29 30.5 27.9926 30.5
    26.75V15.5C30.5 14.2513 29.555 13.25 28.4 13.25Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default ResourcesNavFilled;
